import React from 'react';
import ReactDOM from 'react-dom';
import { unmountComponentByNode } from 'react/utils/renderUtils';

import { CrudWrapper } from 'react/containers/layout/Crud';

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PowerLookup = (function () {

    function PowerLookup () {

        Monet.UI.Fields.TextField.apply (this, arguments);

        var postRenderListeners = [];

        var getHeightGrid = function (scope) {

            return function () {

                return (scope.resultContainer.offsetHeight - scope.gridContainerEl.offsetTop);

            };

        }(this);

        this.value = {
            id: '',
            description: ''
        };

        this.listenersToAfterSelectRow = [];
        this.baseSelector = '';
        this.enableColumnCheckBok = false;
        this.nameSpace = '';
        this.layoutNameSpace = '';
        this.customCriteriaChain = null;
        this.displayKey = 'key';
        this.onBlur = () => undefined;
        this.onFocus = () => undefined;
        this.onChange = () => undefined;
        this.timer = null;
        this.datepickerContainer = null;

        this.setCustomCriteriaChain = function (customCriteriaChain) {
            this.customCriteriaChain = customCriteriaChain;
        }

        this.setBaseSelector = function (baseSelector) {
            this.baseSelector = baseSelector;
        };

        this.setNameSpace = function (nameSpace) {
            this.nameSpace = nameSpace;
            if(!this.layoutNameSpace) {
                this.layoutNameSpace = nameSpace;
            }
        };
        this.setLayoutNameSpace = function (layoutNameSpace) {
            this.layoutNameSpace = layoutNameSpace;
        };

        this.setLookUpEntity = function (entity) {
            this.lookUpEntity = entity;
        };

        this.setDisplayKey = function (column) {
            this.displayKey = column;
        };

        this.setContainerGrid = function (containerGrid) {
            this.containerGrid = containerGrid;
        };

        this.setCustomExecuteFilter = function (customExecuteFilter) {
            if (this.filter) {
                this.filter.setCustomExecuteFilter(customExecuteFilter);
            }
            this.customExecuteFilter = customExecuteFilter;
        };

        this.getValue = function () {
            const id = this.getFilterValue();
            return id ? { id } : id;
        };

        this.getFilterValue = function () {

            var id = this.value.id;

            if(this.idHidden){
                this.value.id = this.idHidden.value;
                id = this.value.id;
            }

            if (id) {
                return parseInt(id);
            }

            return '';
        };

        this.getFullValue = function () {

            if(this.input && this.idHidden){
                if(typeof this.value.description === "undefined") {
                    this.value.description = ""
                }
                this.value.id = this.idHidden.value;
                this.value[this.displayKey] = this.getInputValue();
            }

            return this.value;
        };

        this.getInputValue = function (){
            return this.input.value;
        };

        var getFormatedValue = (function(scope) {
            return function (valueObj) {
                var key = valueObj.key;
                var displayKeyValue = valueObj[scope.displayKey];

                var value = Monet.I18n.getResourcesByKey(displayKeyValue || key || '');

                if(key && displayKeyValue && key !== displayKeyValue ){

                    if(scope.displayKey !== 'key'){
                        value = displayKeyValue + " - " +  key;
                    } else {
                        value = displayKeyValue + " - " +  valueObj.description || valueObj.name;
                    }

                }
                return value;
            };
        }(this));

        this.setValue = function (valueObj, options) {

            if (valueObj) {
                const valueToShow = valueObj[this.displayKey] || valueObj.name;
                this.value.id = valueObj.id;

                if (Object.keys(valueObj).length > 1) {
                    this.value.description =  Monet.I18n.getResourcesByKey(valueToShow);
                    this.value.model = valueObj.model || valueObj;
                    this.setInputValue();
                    this.setFormattedValue(valueObj);
                } else {
                    var requestFieldData = function () {
                        this.requestWithFieldID(function (collection) {
                            this.setValue(collection.at(0).attributes);
                        }.bind(this));
                    }.bind(this);

                    this.idHidden.value = valueObj.id;

                    if (this.filter) {
                        requestFieldData();
                    } else {
                        this.setAfterCreateFilter(requestFieldData);
                    }
                }
            } else {
                this.clear(options);
            }

            this.triggerChange(options);
        }.bind(this);

        this.setFormattedValue = function (valueObj){
            var value = getFormatedValue(valueObj);
            this.formattedValue.value = value;

            this.formattedValue.style.display = 'inline-block';
            this.input.style.display = 'none';
        };

        this.setInputValue = function () {
            var id = this.value.id || '',
                description = this.value.description || '';

            if(this.idHidden && this.input){
                this.idHidden.value = id;
                this.input.value = description;
            }

        };

        this.setOnBlur = (onBlur) => {
            if (onBlur) {
                this.onBlur = onBlur;
            }
        };

        this.setOnFocus = (onFocus) => {
            if (onFocus) {
                this.onFocus = onFocus;
            }
        };

        this.setOnChange = (onChange) => {
            if (onChange) {
                this.onChange = onChange;
            }
        };

        this.triggerChange = ({ doNotTriggerChange } = {}) => {
            if (!doNotTriggerChange) {
                this.onChange();
                this.onBlur();
            }
        };

        this.disable = function () {
            this.inputContainer.classList.add('disabled');
            this.input.disabled = true;
            this.formattedValue.disabled = true;
        };

        this.enable = function () {
            this.inputContainer.classList.remove('disabled');
            this.input.disabled = false;
            this.formattedValue.disabled = false;
        };

        this.clear = function (options) {
            this.setValue({
                description: '',
                id: ''
            }, options);
        };

        this.listenerToAfterSelectRow = function () {
            const rowData = this.grid.getDataItem(this.grid.getSelectedRows());
            const data = rowData.model.attributes;
            data.id = rowData.idOfObject;
            this.setValue(data);
            this.setFieldTextToFilterBuilder();
            this.hideContainer();

            this.listenersToAfterSelectRow.forEach(listener => {
                listener(data);
            });
        };

        this.addListenerToAfterSelectRow = function(callback) {
            this.listenersToAfterSelectRow.push(callback);
        };

        this.createGridContainer = function () {

            this.gridContainerEl = document.createElement('div');
            this.gridContainerEl.className = 'MonetUIFieldsLookupGridContainer';
            this.gridContainerEl.id = 'MonetUIFieldsLookupGridContainer_' + this.lookUpEntity.toLowerCase();

        };

        this.createFloatContainer = function () {

            this.resultContainer     = document.createElement('div');
            this.maximizeFilterBtn   = document.createElement('div');
            this.configureGridLayout = document.createElement('div');
            this.filterContainer     = document.createElement('div');

            this.resultContainer.className     = 'MonetUIFieldsLookupFloatResultContainer';
            this.maximizeFilterBtn.className   = 'MonetUIFieldsLookupMaximizeFilterFields';
            this.configureGridLayout.className = 'MonetUIFieldsLookupConfigureGridLayout';

            if (navigator.userAgent.indexOf('Windows') !== -1) {
                this.maximizeFilterBtn.style.right = '43px';
            }

            this.resultContainer.appendChild(this.maximizeFilterBtn);
            this.resultContainer.appendChild(this.configureGridLayout);
            this.resultContainer.appendChild(this.filterContainer);
            this.resultContainer.appendChild(this.gridContainerEl);

        };

        this.createElement = function () {

            this.inputContainer = document.createElement('div');
            this.inputContainer.className = 'lookupInputContainer';

            this.input = document.createElement('input');
            this.input.type = 'text';
            this.input.className = 'lookUpField';
            this.input.style.display = 'none';
            this.input.setAttribute('rel', this.displayKey);
            this.input.setAttribute('autocomplete', 'off');

            this.formattedValue = document.createElement('input');
            this.formattedValue.className = 'formattedValue lookUpField';
            this.formattedValue.type = 'text';

            this.searchButton = document.createElement('div');
            this.searchButton.className = 'lookupSearchButton';

            this.inputContainer.appendChild(this.formattedValue);
            this.inputContainer.appendChild(this.input);
            this.inputContainer.appendChild(this.searchButton);

            // Keep compatibility with Monet.FormBuilder 1 which retrieves fields values directly from HTML
            this.idHidden = document.createElement ('input');
            this.idHidden.type = 'hidden';
            this.idHidden.className = 'modelAttribute';

            if (this.isMandatory()) {
                this.idHidden.className += ' mandatory';
                this.input.className += ' mandatory';
            }

            this.rootEl.appendChild(this.idHidden);

            const resultContainerWrapper = document.createElement('div');
            resultContainerWrapper.appendChild(this.resultContainer);

            this.lookupContainer = document.createElement('div');
            this.lookupContainer.className = 'lookupContainer';
            this.lookupContainer.appendChild(this.inputContainer);
            this.lookupContainer.appendChild(resultContainerWrapper);
            this.rootEl.appendChild(this.lookupContainer);
        };

        this.setTextLabel = function (content) {
            if (this.label && content) {
                this.label.innerHTML = '<span>'+ content + '</span>';
            }
        };

        this.setInputName = function (name) {

            this.name = name;

            if (this.idHidden) {
                this.idHidden.id   = name + '_id';
                this.idHidden.name = name + '.id';
            }

            if (this.input) {
                this.input.id   = name + '_description';
                this.input.name = name + '_description';
            }

            this.label.setAttribute('for', name + '_description');
        };

        this.setRequestFilter = function (filter){
            this.requestFilter = filter;
        };

        this.setRequestBody = function (requestBody){
            this.requestBody = requestBody;
        };

        this.setAfterCreateFilter = function(afterCreateFilter) {
            this.afterCreateFilter = afterCreateFilter;
        };
        this.getAfterCreateFilter = function() {
            return this.afterCreateFilter;
        };

        this.getRequestFilter = function (){
            return this.requestFilter || '/filter?criteria={"firstResult":0,"maxResults":10}';
        };

        this.getRequestBody = function () {
            return this.requestBody;
        };

        var getClassSafari = function () {
            var userAgent = navigator.userAgent.toLowerCase();

            var isSafari = userAgent.indexOf('safari/') > -1 && userAgent.indexOf('chrome/') === -1;


            return (isSafari ? 'safari': '');

        };

        this.isInsideFilterBuilder = () => {
            return this.rootEl.classList.contains('MonetUIFilterBuilderFilterEl');
        };

        this.calcPositionClass = function () {
            const insideFilterBuilder = this.isInsideFilterBuilder();
            let classPosition = '';
            const safariClass = getClassSafari();
            const containerWidth = this.resultContainer.offsetWidth;

            if (insideFilterBuilder) {
                classPosition = 'filterBuilderLookup';
                const top = this.rootEl.getBoundingClientRect().top + this.rootEl.offsetHeight;
                this.resultContainer.style.top = `${top}px`;
            }

            const positionX = this.input.getBoundingClientRect().left || this.formattedValue.getBoundingClientRect().left;
            if (insideFilterBuilder && positionX + this.resultContainer.offsetWidth > window.innerWidth) {
                classPosition = 'filterBuilderLookupRight';
            } else if (!insideFilterBuilder && positionX + containerWidth > window.innerWidth) {
                classPosition = 'formBuilderLookupRight';
            }

            return ` ${classPosition} ${safariClass} `;
        };

        this.hideOnEsc = (e) => {
            if (e.keyCode === 27) {
                this.hideContainer();
            }
        };

        this.hideOnOutsideClick = (e) => {
            if (!this.resultContainer.contains(e.target) &&
                !this.searchButton.contains(e.target) &&
                !this.filter.elFieldList.contains(e.target) &&
                !this.datepickerContainer?.contains(e.target) &&
                !['Prev', 'Next'].includes(e.target.innerHTML) &&
                e.target.nodeName !== 'BODY'
            ) {
                this.hideContainer();
            }
        };

        this.showContainer = () => {
            document.addEventListener('keyup', this.hideOnEsc);
            document.addEventListener('click', this.hideOnOutsideClick);
            this.resultContainer.classList.add('show');
            this.resultContainer.className += this.calcPositionClass();

            if (this.grid) {
                if (this.grid.getDataLength() > 0) {
                    this.grid.setSelectedRows([0]);
                } else {
                    this.grid.setSelectedRows([]);
                }
            }

            this.executeClearFilter();
            this.adjustGridHeight();

            if (Greenmile.Platform.browser.name !== 'MSIE') {
                this.resultContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        };

        this.hideContainer = () => {
            this.resultContainer.classList.remove('show');
            document.removeEventListener('keyup', this.hideOnEsc);
            document.removeEventListener('click', this.hideOnOutsideClick);
        };

        this.isShowingContainer = () => {
            return this.resultContainer.classList.contains('show');
        }

        this.toggleContainer = (e) => {
            if (!this.isShowingContainer()) {
                this.showContainer(e);
                const hasStatusBar = this.statusBarContainer ? 'hasStatusBar' : '';
                const positionClass = this.calcPositionClass();
                this.resultContainer.className = 'MonetUIFieldsLookupFloatResultContainer show' + positionClass + hasStatusBar;
            } else {
                this.hideContainer();
            }
        };

        this.getCriteria = function() {
            return {
                criteriaChain: [{
                    and: [{
                        attr: "id",
                        eq: this.getValue().id
                    }]
                }]
            };
        }.bind(this);

        this.requestWithFieldID = (function (scope) {

            return function (success) {
                const projection = JSON.stringify({
                    filters: [
                        "id",
                        "key",
                        "description",
                        "icon"
                    ]
                });
                scope.filter.setProjection(projection);

                var collectionFunc = App.Collections[scope.lookUpEntity+'s'];
                var collection = new collectionFunc ();
                var criteria = scope.getCriteria();

                scope.filter.setPaginationFirstZero(scope.nameSpace);

                collection.reset();
                collection.filterWithRestrictions({
                    restrictionUrl: this.url,
                    filter: criteria,
                    criteria: scope.filter.getProjection().toString(),
                    success: success || scope.filter.callbackSuccess
                });

            };

        }(this));

        this.setFieldTextToFilterBuilder = () => {
            const fields = this.filter.fields;
            const representativeKey = this.displayKey;
            const modelObj = this.value.model;
            let fieldToAdd = representativeKey;

            if (modelObj && (typeof modelObj[representativeKey] === 'undefined' || modelObj[representativeKey] === null)) {
                fieldToAdd = (modelObj?.key || representativeKey === 'key') ? 'key' : 'name';
            }

            if (!this.filter.selectedFilters[fieldToAdd]) {
                this.filter.addSelectedFilter (
                    this.filter, App.Forms[this.nameSpace].fields[fieldToAdd], ''
                );
            }

            if (fields[fieldToAdd]) {
                const value = this.input.value || '';
                if (value) {
                    fields[fieldToAdd].setValue ('*' + value + '*');
                } else {
                    fields[fieldToAdd].clear();
                }
            }
        };

        this.executeClearFilter = () => {
            if (this.isShowingContainer() && this.filter) {
                this.setFieldTextToFilterBuilder();
                this.filter.setPaginationFirstZero(this.nameSpace);
                this.filter.executeFilter();
            }
        };

        this.clearFilterUserAction = () => {
            if ((!this.idHidden.value || !this.input.value) && this.getValue().id) {
                this.clear();
            }
        };

        this.selectRows = () => {
            const lookupListSession = Monet.Session[this.nameSpace];

            // If it's a Lookup List field and all items were selected, send request to select them all,
            // otherwise keep default behavior
            if (this.statusBarContainer && lookupListSession && lookupListSession.selectedAll) {
                this.btnGetItemsChecked.classList.add('disabled');
                const criteriaChain = this.filter.criteriaChain;
                criteriaChain.criteriaChain[0].and = criteriaChain.criteriaChain[0].and.concat(lookupListSession.notSelectedItems || []);
                const projection = this.customProjectionSelectAll
                    ? this.customProjectionSelectAll
                    : {
                        filters: ["id", this.displayKey],
                        firstResult: 0,
                        maxResults: 1000,
                    };
                const collection = new App.Collections[this.lookUpEntity+'s']();
                collection.filterWithRestrictions({
                    criteria: JSON.stringify(projection),
                    filter: criteriaChain,
                    success: (data) => {
                        const allItemsSelected = data && data.models;
                        this.listenerToAfterSelectRow(allItemsSelected);
                    }
                });
            } else {
                this.listenerToAfterSelectRow();
            }
        };

        this.addEventListeners = function () {

            const showFormattedValueInput = (function(scope) {
                return function () {
                    scope.formattedValue.style.display = 'inline-block';
                    scope.input.style.display = 'none';
                };
            }(this));

            const showInput = () => {
                this.formattedValue.style.display = 'none';
                this.input.style.display = 'inline-block';
                this.input.focus();
                this.divLookupList && this.divLookupList.classList.remove('canShowList');
            };

            const verifyAndShowContainer = () => {
              if (document.activeElement.id === this.input.id) {
                this.showContainer();
              }
            }

            this.searchButton.addEventListener('click', (e) => {
                if (this.filter) {
                    this.filter.clearFilter();
                }

                if (!this.input.disabled) {
                    this.toggleContainer(this, e);
                }
            });

            if (this.divLookupList && this.canShowList) {
                this.searchButton.addEventListener('mouseenter', () => {
                    this.divLookupList.classList.remove('canShowList');
                });

                this.searchButton.addEventListener('mouseleave', this.canShowList);
            }

            this.removeAllElementsButton && this.removeAllElementsButton.addEventListener('click', () => {
                this.clear();
            });

            this.input.addEventListener('keydown', (e) => {
                e.stopPropagation();
                switch (e.keyCode) {
                  case 40:
                    if (!this.isShowingContainer()) {
                      this.showContainer(e);
                      this.grid.setSelectedRows([0]);
                    } else if (this.grid.getDataLength() > 1) {
                      this.grid.gotoCell(1, 0);
                      this.grid.setSelectedRows([1]);
                    }
                    break;
                  case 27:
                    this.grid.setSelectedRows([]);
                    this.hideContainer();
                    break;
                  case 13:
                    if (this.grid.getDataLength() > 0 && this.isShowingContainer()) {
                      this.input.blur();
                      this.grid.setSelectedRows([0]);
                      this.listenerToAfterSelectRow();
                    }
                    verifyAndShowContainer();
                    break;
                  default:
                    clearTimeout(this.timer);
                    this.timer = setTimeout(verifyAndShowContainer, 350);
                    break;
                }
            });

            $(this.input).on("cut", this.clearFilterUserAction);

            this.input.addEventListener('blur', (e) => {
                e.stopPropagation();
                showFormattedValueInput();
                this.clearFilterUserAction();
                this.input.value = this.value.description || '';
                this.canShowList && this.canShowList();
            });

            this.adjustGridContainer = function() {

                const filterFields = this.filterContainer.querySelector('.MonetUIFilterBuilder');
                let gridHeight = getHeightGrid();

                if (filterFields.style.display === 'none') {

                    filterFields.style.display = 'block';
                    this.gridContainerEl.style.marginTop = '10px';

                    if( gridHeight > 0 ) {
                        gridHeight = gridHeight + 10;
                        this.gridContainerEl.style.height = gridHeight + 'px';
                    }

                } else {

                    filterFields.style.display = 'none';
                    this.gridContainerEl.style.height = '240px';
                    this.gridContainerEl.style.marginTop = '0';

                }
                this.grid.resizeCanvas();
                this.adjustGridHeight();
            };

            this.adjustGridHeight = function () {
                const entity = App.Forms[this.nameSpace];
                if (entity.table) {
                    entity.table.resizeCanvas();
                    entity.filterBuilder.adjustHeaderSize();
                }
            };

            this.maximizeFilterBtn.addEventListener ('click', (function (scope) {
                return function (e) {
                    e.stopPropagation();
                    scope.adjustGridContainer();
                };
            }(this)));

            if (this.btnGetItemsChecked) {
                this.btnGetItemsChecked.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (this.grid.getDataLength() && this.grid.getSelectedRows().length) {
                        this.selectRows();
                    } else {
                        this.hideContainer();
                    }
                });
            }

            this.resultContainer.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            this.formattedValue.addEventListener('focus', (e) => {
                e.stopPropagation();
                this.onFocus();
                showInput();
            });

        };

        this.initializeFilterBuilder = function () {

            var projection = new Monet.Builder.Projection();
            var options = Monet.Grid.Utils.paginationOptions;
            var beforeFilter;

            App.Forms[this.nameSpace].pagination = {
                first: options.FIRST,
                max: options.MAX_RESULT,
                blocked: false,
                canIncrement: true
            };

            if (this.requestBody) {
                beforeFilter = (function (scope) {

                    return function () {

                        if (scope.requestBody.criteriaChain) {

                            var arrayAnds = scope.requestBody.criteriaChain[0]['and'];

                            if(scope.customCriteriaChain) {
                                this.criteriaChain.criteriaChain[0].and = this.criteriaChain.criteriaChain[0].and.concat(scope.customCriteriaChain);
                            }

                            for (var i = 0; i < arrayAnds.length; i++) {
                                this.criteriaChain.criteriaChain[0].and.push(arrayAnds[i]);
                            }

                        }
                    };

                }(this));
            }

            projection.addField({name: this.displayKey});
            projection.setLayout(this.pageLayout);
            projection.setPagination(App.Forms[this.nameSpace].pagination);
            projection.parseLayout();

            if (!this.filterContainer.innerHTML) {
                this.filter = new Monet.UI.FilterBuilder ();
                if(this.customCriteriaChain){
                    this.filter.changeCriteriaBeforeFilter = function(criteria){
                        criteria.criteriaChain[0].and = criteria.criteriaChain[0].and.concat(this.customCriteriaChain);
                        return criteria;
                    }.bind(this);
                }
            }

            var defaultFilters = {};
            defaultFilters[this.displayKey] = '';
            this.filter.setWillLoadState (false);
            this.filter.setEntity (this.lookUpEntity);
            this.filter.setCustomNameSpace(this.nameSpace);
            this.filter.setIdScreen(Monet.Utils.GetTabName());
            this.filter.setFieldsOverride ({
                LOOKUP: 'TEXT',
                LOOKUP_LIST: 'TEXT',
                TEXT_AREA: 'TEXT',
                TAG: 'TAG_FILTER'
            });
            this.filter.setDefaultFilters(defaultFilters);
            this.filter.setSelectedFilters({});
            this.filter.fields = {};
            this.filter.setProjection(projection.projection.toString());
            this.filter.setSelector (this.baseSelector || this.id + ' .MonetUIFieldsLookupGridContainer.ui-widget');
            this.filter.setCallbacks({
                success: (function (scope){
                    return function (data, token) {

                        if (token === scope.filter.lastToken) {

                            if (Monet.Session[scope.nameSpace]) {
                                Monet.Session[scope.nameSpace].notSelectedItems = null;
                                Monet.Session[scope.nameSpace].allDataSelectedLength = null;
                                Monet.Session[scope.nameSpace].selectedAll = false;
                            }

                            Monet.Grid.addDataToGrid (scope.nameSpace, scope.columns, data, true);
                            if (App.Forms[scope.nameSpace].table) {
                                App.Forms[scope.nameSpace].table.resizeCanvas();
                            }

                            if (data.size() === 0) {
                                scope.grid.setSelectedRows([]);
                            } else {
                                scope.grid.setSelectedRows([0]);
                            }

                        }

                    };
                }(this)),
                beforeFilter: beforeFilter
            });

            if (this.customExecuteFilter) {
                this.filter.setCustomExecuteFilter(this.customExecuteFilter);
            }

            this.filter.getFieldList(() => {
                this.filter.render(this.executeClearFilter);
            });

            this.filter.customAdjustHeaderSize = (function (scope) {
                return function () {
                    if (scope.isShowingContainer()) {
                        scope.gridContainerEl.style.height = getHeightGrid() + 'px';
                        scope.grid.resizeCanvas();
                    }
                };
            }(this));

            this.filter.el.style.display = 'none';

            if (!this.filterContainer.innerHTML) {

                App.Forms[this.nameSpace].filterBuilder = this.filter;

                this.filterContainer.innerHTML = '';

                this.filterContainer.appendChild(this.filter.el);

            }

            if (this.meta && this.meta.afterCreateFilter) {
              try {
                this.setAfterCreateFilter(eval(this.meta.afterCreateFilter)(this));
              } catch (e) {
                console.error('afterCreateFilter is not a valid function:', e);
              }
            }
        };

        this.generateLayout = () => {
            const container = document.createElement('div');
            ReactDOM.render(
              <CrudWrapper
                store={window.globalStore}
                entity={this.lookUpEntity}
                isGrid
                isLookup
              />,
              container
            );

            unmountComponentByNode(container);

            App.Forms[this.nameSpace].fields = { ...App.Forms[this.lookUpEntity].fields };
            return Monet.Grid.generateSearchGridLayout(this.lookUpEntity, {
                layoutNamespace: this.layoutNameSpace,
                kind: 'PICKLIST'
            });
        };

        this.getPageLayout = async (forceLayoutUpdate) => {
            const form = App.Forms[this.layoutNameSpace] || {};
            let pageLayout;
            if (!forceLayoutUpdate && form && form.layout && form.layout.lookUpGrid) {
                pageLayout = form.layout.lookUpGrid;
            } else {
                const request = new Monet.Ajax();
                request.url = 'form/GridLayout/' + this.lookUpEntity + '/Type/PICKLIST?' + new Date().getTime();
                const responseLayout = await request.send();
                const gridLayout = (responseLayout && responseLayout.id) ? responseLayout : this.generateLayout();
                pageLayout = {
                    sections: [{
                        sectionRelatedLists: [
                            {
                                searchGridLayout: gridLayout
                            }
                        ]
                    }]
                };

                App.Forms[this.layoutNameSpace] = {
                    ...form,
                    layout: {
                        ...form.layout,
                        lookUpGrid: pageLayout
                    }
                };
            }
            return pageLayout;
        }

        this.initializeGrid = async function ({ forceLayoutUpdate } = {}) {

            const options  = {
                entity: this.nameSpace || this.lookUpEntity,
                columnCheckBox: {
                    show: this.enableColumnCheckBok
                },
                gridContainner: this.containerGrid,
                multiSelect: this.enableColumnCheckBok,
                selecteRows: true,
                enableCellNavigation: false,
                columnEdit: {
                    show : false
                },
                multiColumnSort: true,
                rowHeight: 22
            };

            const customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            const selector = this.baseSelector + ' .MonetUIFieldsLookupConfigureGridLayout';
            App.Forms[this.nameSpace] = App.Forms[this.nameSpace] || {};

            if (!this.pageLayout || forceLayoutUpdate) {
                this.pageLayout = await this.getPageLayout(forceLayoutUpdate);
            }

            this.columns = Monet.Grid.getGridLayout(this.pageLayout, this.nameSpace);
            const dataView = new Monet.Grid.DataProvider(this.columns, null, this.nameSpace);

            App.Forms[this.nameSpace].table = this.grid;
            App.Forms[this.nameSpace].dataProvider = dataView;
            if (App.Forms[this.lookUpEntity]?.fields) {
                const fieldsDeepCloned = JSON.parse(JSON.stringify(App.Forms[this.lookUpEntity].fields));
                App.Forms[this.nameSpace].fields = fieldsDeepCloned;
            }

            this.grid = new Monet.Grid.GenericGrid(
                this.gridContainerEl, dataView, this.columns, options
            );

            if (!options.multiSelect) {
                this.grid.onClick.subscribe((e, args) => {
                    this.grid.setSelectedRows([args.row]);
                    this.listenerToAfterSelectRow();
                });
            }

            this.grid.onKeyDown.subscribe((event, args) => {
                if (event.keyCode === 13) {
                    this.listenerToAfterSelectRow();
                } else if (event.keyCode === 27) {
                    this.grid.setSelectedRows([]);
                    this.hideContainer();
                } else if (event.keyCode === 38) {
                    this.grid.scrollRowIntoView(args.row - 1);
                } else if (event.keyCode === 40) {
                    this.grid.scrollRowIntoView(args.row + 1);
                }
            });

            const elementToCustomizeColumns = this.rootEl.querySelector(selector);

            if (elementToCustomizeColumns) {

                elementToCustomizeColumns.innerHTML = '';

                customizeColumns.setEntity(this.lookUpEntity);
                customizeColumns.setScreenName(this.nameSpace);
                customizeColumns.setLayoutNameSpace(this.layoutNameSpace);
                customizeColumns.setSelector(selector);
                customizeColumns.setElement(elementToCustomizeColumns);
                customizeColumns.setActionToGridLayout('lookUpGrid');
                customizeColumns.setCallBacks({
                    afterSaveList: () => {
                        this.initializeGrid({ forceLayoutUpdate: true });
                    },
                    afterInit: () => {
                        const btnCustomizeColumns = this.configureGridLayout.querySelector('.gridCustomColumnsBtn');
                        this.gridContainerEl.style.marginTop = '25px';

                        if (btnCustomizeColumns) {
                            if (navigator.userAgent.indexOf('Windows') !== -1) {
                                btnCustomizeColumns.style.right = '20px';
                            }
                            if (this.resultContainer.parentNode.className === 'MonetUIFilterBuilderFilterEl') {
                                btnCustomizeColumns.style.top = '0';
                            }
                        }
                    }
                });
                customizeColumns.init();
            }

            this.grid.pagination.getDataAndUpdateGrid = () => {

                this.filter.criteriaChain = this.filter.changeCriteriaBeforeFilter(this.filter.getCriteriaChain());

                if (this.filter.callbackBeforeFilter) {
                    this.filter.callbackBeforeFilter();
                }

                const collection = new App.Collections[this.lookUpEntity + 's']();
                collection.filterWithRestrictions({
                    criteria: this.filter.getProjection(),
                    filter: this.filter.criteriaChain,
                    success: (collection) => {
                        const currentLength = this.grid.getDataLength();
                        Monet.Grid.appendDataToGridAfterPagination(this.nameSpace, this.grid.getColumns(), collection);

                        // If it's a Lookup List field and all items were selected,
                        // checks new items appearing after grid pagination
                        const lookupListSession = Monet.Session[this.nameSpace];
                        if (this.statusBarContainer && lookupListSession && lookupListSession.selectedAll) {
                            const newArray = collection.models.map((item, index) => index + currentLength);
                            this.grid.setSelectedRows(this.grid.getSelectedRows().concat(newArray));
                        }
                    }
                });


            };

            this.initializeFilterBuilder();

            if (this.afterCreateFilter) {
                this.afterCreateFilter();
            }

            this.adjustGridContainer();

            App.Forms[this.nameSpace].lookupElement = this;
        };

        this.render = function () {
            this.createGridContainer();
            this.createFloatContainer();
            this.createElement();
            this.addEventListeners();
            this.initializeGrid();
            if (!App.Forms[this.nameSpace]) {
                App.Forms[this.nameSpace] = {};
            }

            this.rootEl.classList.add('lookupFieldContainer');
            this.datepickerContainer = document.querySelector('#ui-datepicker-div');

            return this.rootEl;
        };

        /**
         * postRender event firer
         *
         * Use this event to interact with the rendered lookup elements. To add
         * interactions, create a private method and execute it inside me.
         * @public
         */
        this.postRender = function () {
            for(var i=0, length =postRenderListeners.length; i< length ; i++ ){
                postRenderListeners[i]();
            }
        };

        this.addPostRender = function(listener) {
            postRenderListeners.push(listener);
        };

    }

    return PowerLookup;

})();
